/**
 * Tiny reactive voice-state store. Wraps a value and a listener list
 * so the sprite renderer and UI surfaces can all react to state
 * transitions without a framework dependency.
 */

import type { VoiceState } from "../types";

type Listener = (next: VoiceState, previous: VoiceState) => void;

export class VoiceStateStore {
  private currentState: VoiceState = "idle";
  private listeners = new Set<Listener>();

  get(): VoiceState {
    return this.currentState;
  }

  set(next: VoiceState): void {
    if (next === this.currentState) return;
    const previous = this.currentState;
    this.currentState = next;
    this.listeners.forEach((listener) => listener(next, previous));
  }

  subscribe(listener: Listener): () => void {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  }
}
